import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { ChangeDigitalSignature } from './model/change-digital-signature';
import { ChangeDigitalSignatureEventType } from './change-digital-signature.event.type';

@Component({
	selector: 'app-change-digital-signature',
	templateUrl: './change-digital-signature.component.html',
	styleUrls: ['./change-digital-signature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangeDigitalSignatureComponent implements OnInit, OnDestroy {
	public subtitle = [
		`Se você perdeu, esqueceu ou simplesmente deseja alterar sua assinatura eletrônica,<br>
		é possível redefiní-la.<br><br>
		Ela deve ter no mínimo 6 dígitos numéricos.<br><br>
		Procure memorizar sua assinatura eletrônica ou guarda-lá em lugar seguro.`,
		'A partir de agora esta será a sua nova assinatura eletrônica.'
	];
	public showStepButtons = true;
	public flow: Array<string> = [
		ChangeDigitalSignatureEventType.SEND.CHANGE_DG_SIGNATURE_SEND,
		ChangeDigitalSignatureEventType.SEND.CHANGE_DG_SIGNATURE_CONFIRM
	];
	public flowIndex = 0;
	public form: FormGroup;
	public submited: boolean;
	public activeBackButton = false;
	public changeDigitalSignatureData: ChangeDigitalSignature  = new ChangeDigitalSignature();

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});

		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.BUTTONS, data => {
			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});
		});

		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.ERROR, (data): any => {
			this.flowIndex = this.flow.findIndex((item, index, array) => {
				return item === data.step;
			});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.BUTTONS);
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.ERROR);
	}

	show() {
		AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.LOGIN.SECURITY_CHECK, {show: true});
	}

	setForm(form: FormGroup) {
		this.form = form;
	}

	sendForm(event) {
		this.submited = true;

		if (this.form.valid) {
			this.submited = false;

			AppEventDispatcher.dispatch(this.flow[this.flowIndex], null);
			this.flowIndex++;
		}
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/change-digital-signature.component.ts